
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/valueplan",
      function () {
        return require("private-next-pages/valueplan.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/valueplan"])
      });
    }
  